queryMatches = (first, second) ->
  first.toLowerCase().indexOf( second.toLowerCase().trim() ) != -1
App.AdvertsEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()
  env:      Em.inject.service('environment')

  needs: [ 'adverts' ]

  clients_count: 0
  loading_clients_count: false
  clients_count_timeout: null
  old_recurrence: null
  isExecuting: false
  isCancelling: false
  statistics: null
  statisticsLoading: false

  promosBinding: 'controllers.adverts.model.promos'
  organizationBinding: 'advert.organization'
  restaurantsBinding: 'controllers.adverts.model.restaurants'

  recurrence: ( ->
    @get('advert.availableRecurrence')
  ).property()


  advertBinding: 'model'

  isLoading: false

  clientTags: null

  currentTab: 'main'

  selectedRestaurans: Em.computed.gt('advert.restaurants.length', 0)
  selectedRestaurantNames: ( ->
    r = @get('advert.restaurants').map((e) -> e.get('name')).join(', ')
    # todo i18n
    return Em.I18n.t 'advert.filter.restaurants.zero_data' if r == ''
    Em.I18n.t 'advert.filter.restaurants.content', restaurants: r
  ).property('advert.restaurants')

  isMainPage:     Em.computed.equal('currentTab', 'main')
  isPreviewPage:  Em.computed.equal('currentTab', 'preview')
  isDeliveryPage: Em.computed.equal('currentTab', 'delivery')
  isStatsPage:    Em.computed.equal('currentTab', 'stats')

  statusText: (->
    @get('env').translate("advert.status.#{@get('advert.delivery_status')}")
  ).property('advert.delivery_status')

  showExecuteButton: (->
    !@get('advert.isNew') && @get('advert.delivery_status') != 'scheduled'
  ).property('advert.isNew', 'advert.delivery_status')

  cantEditScheduledAt: (->
    @get('advert.delivery_status') == 'scheduled'
  ).property('advert.delivery_status')

  loadStatistics: (->
    if @get('isStatsPage')
      @set('statisticsLoading', true)

      @get('advert').getStatistics()
      .then (_data) =>
        data = _data && _data['statistics']
        if data
          data.forEach (v) =>
            v.transport_text = @get('env').translate("advert.transport.#{v.transport}")

        @set('statistics', data)
        @set('statisticsLoading', false)

  ).observes('currentTab', 'advert')

  fakeRecurrenceChangeWatcher: (->
    setTimeout =>
      @fakeRecurrenceChangeWatcher()
    , 1000
    return if @get('advert.recurrence') == null and @old_recurrence == null
    new_recurrence = if @get('advert.recurrence') then @get('advert.recurrence').join(',') else ''
    @get('advert.recurrence')
    @notifyPropertyChange('advert.recurrence') if new_recurrence != @old_recurrence
    @set('old_recurrence', new_recurrence)
  ).on('init')

  clientCountWatcher: (->
    @set('clients_count', null)
    @set('loading_clients_count', true)
    clearTimeout(@get('clients_count_timeout'))
    @set('clients_count_timeout', setTimeout =>
      @get('advert').nonRESTAction('GET', 'clients_count', {
        client_tag_ids: @get('advert.client_tags').map((t)->t.id),
        restaurant_ids: @get('advert.restaurants').map((r)->r.id),
        recurrence: @get('advert.recurrence'),
        was_orders_after: JSON.stringify(@get('advert.was_orders_after')),
        was_orders_before: JSON.stringify(@get('advert.was_orders_before')),
        no_orders_after: JSON.stringify(@get('advert.no_orders_after')),
        no_orders_before: JSON.stringify(@get('advert.no_orders_before'))
      })
      .then (response)=>
        @set('loading_clients_count', false)
        @set('clients_count', response.clients_count)
    , 3000)
  ).observes(
    'advert.restaurants',
    'advert.recurrence',
    'advert.was_orders_after',
    'advert.was_orders_before',
    'advert.no_orders_after',
    'advert.no_orders_before',
    'advert.client_tags'
  )

  # todo i18n
  linkExample: (->
    "Например, http://#{@get('advert.organization.host')}#/ad/#{@get('advert.short_sid')}"
  ).property('advert.link')

  approximatelyClientCount: (->
    clients_count = @get('clients_count')
    clients_count = 0 if clients_count == null
    "#{clients_count} #{@get('env').translate('clients.clients_count', {count: clients_count})}"
  ).property('clients_count')

  saveAdvert: ->
    @get('advert').notifyPropertyChange('availableRecurrenceUpdate')
    tags = @get('advert.client_tags').map (tag) => Number(tag.get('id'))
    @get('advert').set('client_tag_ids', tags)
    @get('advert').save()

  actions:

    wouldUploadPhoto: (permission) ->
      advert = @get('advert')
      return permission.resolve() unless advert.get('isNew')

      # todo i18n
      if confirm Em.I18n.t 'advert.confirm.save'
        @saveAdvert().then =>
          permission.resolve()
        , =>
          permission.reject()
      else
        permission.reject()
      false

    cancel: ->
      advert = @get('advert')

      if advert.get('isDirty') or advert.get('isNew')
        return unless confirm Em.I18n.t 'advert.confirm.cancel'
        advert = @get('advert')
        advert.rollback()

      @send('goBackToAdvertList')

      false

    executeAdvert: ->
      return unless confirm(Em.I18n.t 'advert.confirm.execute', clients: @get('approximatelyClientCount'))

      @set('isExecuting', true)
      @set('isLoading', true)

      advert = @get('advert')
      @saveAdvert()
      .then =>
        @set('isLoading', false)
        advert.execute()
        .then (result) =>
          @get('notifier').pushNotification
            type:     if result.status == 'ok' then 'success' else 'error'
            title:    if result.status == 'ok' then Em.I18n.t 'advert.result.success' else Em.I18n.t 'advert.result.error'
            message:    result.message
          advert.reload()
        .finally =>
          @set('isExecuting', false)

    cancelAdvert: ->
      return unless confirm(Em.I18n.t 'advert.confirm.cancel')

      @set('isCancelling', true)
      @set('isLoading', true)

      advert = @get('advert')
      tags = @get('advert.client_tags').map (tag) => Number(tag.get('id'))
      @get('advert').set('client_tag_ids', tags)
      advert.save()
      .then =>
        @set('isLoading', false)
        advert.cancel()
        .then (result) =>
          @get('notifier').pushNotification
            type:     if result.status == 'ok' then 'success' else 'error'
            title:    if result.status == 'ok' then Em.I18n.t 'advert.result.success' else Em.I18n.t 'advert.result.error'
            message:    result.message
          advert.reload()
        .finally =>
          @set('isCancelling', false)

    deleteAdvert: ->
      return unless confirm Em.I18n.t 'advert.confirm.delete'

      advert = @get('advert')
      advert.destroyRecord()
      .then =>
        @transitionToRoute('adverts')

      false

    saveAdvert: ->
      @set('isLoading', true)
      wasNew = @get('advert.isNew')
      statusText = Em.I18n.t "advert.notifier.status.#{if wasNew then 'new' else 'old'}"
      tags = @get('advert.client_tags').map (tag) => Number(tag.get('id'))
      @get('advert').set('client_tag_ids', tags)
      @saveAdvert()
      .then =>
        @set('isLoading', false)
        @transitionToRoute('adverts')
        @get('notifier').pushNotification
          type:     'success'
          title:    Em.I18n.t 'advert.notifier.title', text: statusText
          duration: 3000

      false


    queryTags: (defer, query) ->
      organization = @get('organization')

      tagsPromise = if @get('clientTags')
        Em.RSVP.resolve( @get('clientTags') )
      else
        @store.find('client_tag', organization_id: organization.get('id'))

      tagsPromise
      .then (tags) =>
        @set('clientTags', tags)
        Em.RSVP.resolve(tags.filter (tag) => queryMatches(tag.get('name'), query))
      .then(defer.resolve, defer.reject)

      false
